import type SVGProps from '~/components/icons/svg-props'

export function InformationIcon(props: SVGProps) {
  const { variant = 'outlined', width = '24', height = '24', ...rest } = props

  return variant === 'outlined' ? (
    <svg width={width} height={height} {...rest} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 17.3488C12.3853 17.3488 12.6977 17.0365 12.6977 16.6512V11.0698C12.6977 10.6845 12.3853 10.3721 12 10.3721C11.6147 10.3721 11.3023 10.6845 11.3023 11.0698V16.6512C11.3023 17.0365 11.6147 17.3488 12 17.3488Z"
        fill="currentColor"
      />
      <path
        d="M12 7.34884C12.5138 7.34884 12.9302 7.76532 12.9302 8.27907C12.9302 8.79282 12.5138 9.2093 12 9.2093C11.4862 9.2093 11.0698 8.79282 11.0698 8.27907C11.0698 7.76532 11.4862 7.34884 12 7.34884Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12 3.39535C7.24778 3.39535 3.39535 7.24778 3.39535 12C3.39535 16.7522 7.24778 20.6047 12 20.6047C16.7522 20.6047 20.6047 16.7522 20.6047 12C20.6047 7.24778 16.7522 3.39535 12 3.39535Z"
        fill="currentColor"
      />
    </svg>
  ) : (
    <svg width={width} height={height} {...rest} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12 17.75C12.4142 17.75 12.75 17.4142 12.75 17V11C12.75 10.5858 12.4142 10.25 12 10.25C11.5858 10.25 11.25 10.5858 11.25 11V17C11.25 17.4142 11.5858 17.75 12 17.75ZM12 7C12.5523 7 13 7.44772 13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7Z"
        fill="currentColor"
      />
    </svg>
  )
}
